export default {
  'department.unassignedMembers': '未分配员工',
  'department.unassigned': '未分配部门',
  'department.column.name': '部门名',
  'department.column.foreign_name': '部门中文名',
  'department.column.description': '描述',
  'department.action.addMembers': '添加员工',
  'department.add.title': '新建部门',
  'department.edit.title': '编辑部门',
  'department.section.generalInformation': '基本信息',
  'department.section.members': '员工',
  'department.addMembers.copy': '选择您想分配给该部门的未分配成员。要更改现有角色分配，请访问 {memberPageLink} 页面。',
  'department.add.success': '新增部门成功',
  'department.edit.success': '更新部门成功',
  'department.delete.title': '确认要删除此部门吗？',
  'department.delete.description': '此部门的员工会挪动到{unassignedDepartmentText}。',
  'department.delete.success': '删除部门成功',
};
